import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexLeaflet',
  setup(__props) {

const Card9 = defineAsyncComponent(() => import("@/components/commen/card/cardData9.vue"))
const simpleMap = defineAsyncComponent(() => import("@/components/theme/maps/simpleMap.vue"))
const multiLanguage = defineAsyncComponent(() => import("@/components/theme/maps/multiLanguage.vue"))
const multiLanguage2 = defineAsyncComponent(() => import("@/components/theme/maps/multiLanguage2.vue"))
let desc = "Display a map with labels in a foreign language"

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Maps",
      title: "Vue Leaflet"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card9), {
          colClass: "col-xl-6 ",
          cardhaderClass: "pb-0 title-header",
          title: "Simple Map"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(simpleMap))
          ]),
          _: 1
        }),
        _createVNode(_unref(Card9), {
          colClass: "col-xl-6 ",
          cardhaderClass: "pb-0 title-header",
          title: "Multi-language support",
          span: "true",
          spanClass: _unref(desc)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(multiLanguage))
          ]),
          _: 1
        }, 8, ["spanClass"]),
        _createVNode(_unref(Card9), {
          colClass: "col-xl-12",
          cardhaderClass: "pb-0 title-header",
          title: "Multi-language support",
          span: "true",
          spanClass: _unref(desc)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(multiLanguage2))
          ]),
          _: 1
        }, 8, ["spanClass"])
      ])
    ])
  ], 64))
}
}

})